import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ready-indicator" }

import { computed } from 'vue';
import RcStatusIndicator from '@components/Pill/RcStatusIndicator/RcStatusIndicator.vue';
import type { Status } from '@components/utils/status';

/**
 * Shows a ready count such as `2/3` next to a dot. The dot is green when everything is ready and red when not
 */
export interface Props {
  /**
   * The text to show, e.g. `2/3`
   */
  value?: string;
  ready?: number;
  total?: number;
  /**
   * Overrides the colour of the dot, e.g. `none` when readiness doesn't apply any more
   */
  status?: Status;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadyIndicator',
  props: {
    value: { default: '' },
    ready: { default: 0 },
    total: { default: 0 },
    status: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const dotStatus = computed<Status>(() => {
  if (props.status) {
    return props.status;
  }

  return props.total > 0 && props.ready >= props.total ? 'success' : 'error';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(RcStatusIndicator, {
      shape: "disc",
      status: dotStatus.value
    }, null, 8, ["status"]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("span", null, _toDisplayString(props.value), 1)
  ]))
}
}

})